<template>
  <f7-page class="accountWallet_page">
    <f7-navbar sliding no-shadow back-link>
      <f7-nav-title v-if="apiWallet">{{ apiWallet.tag }}</f7-nav-title>
      <f7-nav-right>
        <navbarright></navbarright>
      </f7-nav-right>
    </f7-navbar>
    <AppLayout>
      <template #main>
        <f7-card outline header-divider v-if="apiWallet">
          <f7-card-header class="grid grid-rows-1">
            <span
              >{{ apiWallet.tag }}
              <f7-link
                v-if="!apiWallet.shared"
                icon-ios="f7:pencil"
                icon-md="material:edit"
                href="#"
                @click="editApiWallet(apiWallet)"
                style="position: absolute; right: 8px; top: 8px"
              ></f7-link> </span
            ><span style="font-size: small">№: {{ apiWallet.id }}</span>
          </f7-card-header>
          <f7-card-content class="grid grid-rows-2">
            <span>
              {{ $t("common.balance")
              }}<span style="font-size: x-large; font-weight: 500; margin-left: 8px">
                {{
                  $filtersToCurrency.toCurrency(
                    apiWallet.balance,
                    null,
                    apiWallet.currency
                  )
                }}</span
              ></span
            >
            <span>
              {{ $t("common.availaible_balance")
              }}<span style="font-size: large; font-weight: 300; margin-left: 8px">
                {{
                  $filtersToCurrency.toCurrency(
                    apiWallet.balance_available,
                    null,
                    apiWallet.currency
                  )
                }}</span
              ></span
            >
          </f7-card-content>

          <transactionCharts
            v-if="hasStructuredTransactions"
          ></transactionCharts>
          <span
            :class="{ 'grid grid-cols-2': canTransfer }"
          >
            <f7-button
              raised
              large
              fill
              @click="transferFrom(apiWallet)"
              style="border-bottom-left-radius: 16px !important; border-bottom-right-radius: 0px !important"
              class="no-margin-horizontal card_button"
              color="primary"
              v-if="canTransfer"
              >{{ $t("common.tranfer") }}</f7-button
            >
            <f7-button
              raised
              large
              fill
              @click="selectProjectToContribute(apiWallet)"
              :class="{
                'card_button': !canTransfer,
                'no-margin-horizontal buttons': canTransfer
              }"
              color="primary"
              style="border-bottom-right-radius: 16px !important"
              ><span v-if="!apiWallet.shared">{{ $t("common.topUp") }}</span
              ><span v-else>{{ $t("common.contribute") }}</span></f7-button
            ></span
          >
        </f7-card>

          <div
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              
             
        <f7-button
          class="margin-horizontal align-content-center margin-top"
          ripple
                outline
                button-round
                large
                color="auto"
          v-if="!hasTransactions"
          @click="uploadTransactions()"
          icon-ios="f7:refresh"
          icon-md="material:refresh"
          :text="$t('common.uploadTransactions')"
          style="
                  border-radius: 25px;
                  font-size: large;
                  width: max-content;
                "
          border-color="primary"
          ><f7-preloader v-if="isLoading" color="multi" :size="42"></f7-preloader
        ></f7-button>
        </div>
      </template>
      <template #right>
        <getTransactions v-if="hasTransactions"></getTransactions>
      </template>
    </AppLayout>
  </f7-page>
</template>
<style scoped></style>
<script setup>
import { ref, computed, onMounted } from "vue";
import { theme, f7 } from "framework7-vue";
import navbarright from "../components/navbarright.vue";
import AppLayout from "../components/common/AppLayout.vue";
import { useAccount } from "@/js/composables/useAccount.js";
import getTransactions from "../components/modules/transactions.vue";
import transactionCharts from "../components/modules/charts.vue";
import { useApimoneyStore } from "../js/pinia-stores/apimoney.js";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import {
  useTabletScreen,
  useDesktopScreen,
} from "../js/composables/useMediaQuery.js";
import { useAccountStore } from "../js/pinia-stores/account.js";
import { useKeycloakStore } from "../js/pinia-stores/keycloak.js";
import _ from "lodash";

const props = defineProps({
  f7route: Object,
  f7router: Object,
});

const { f7route, f7router } = props;

const {
  userAccount, profile,
  editApiWallet, openItem, openWalletMenu,
  transferFrom, selectProjectToContribute, setAccountMainWallet,
  addApiWallet,
} = useAccount({ f7route, f7router });
const isTablet = useTabletScreen().matches;

const isLoading = ref(false);

const bankAccount = computed(() => useApimoneyStore().bankAccount);
const bankAccountList = computed(() => useApimoneyStore().bankAccountList);
const standard = computed(() => useApimoneyStore().standard);
const business = computed(() => useApimoneyStore().business);
const accountList = computed(() => useApimoneyStore().accountList);
const transactionList = computed(() => useApimoneyStore().transactionList);
const apiWallet = computed(() => useApimoneyStore().apiWallet);
const structuredTransactionList = computed(() => useApimoneyStore().structuredTransactionList);
const isDeskTop = useDesktopScreen();
const documentsUrl = computed(() => useAuthStore().documentsUrl);
const document = computed(() => useAuthStore().document);
const getProfile = computed(() => useAuthStore().profile);
const isAuthenticated = computed(() => !!useAuthStore().token);
const isProfileLoaded = computed(() => !!useAuthStore().profile);
const getusererror = computed(() => useAuthStore().getusererror);
const hasTransactions = computed(() => transactionList.value && transactionList.value.length > 0);
const hasStructuredTransactions = computed(() => structuredTransactionList.value && structuredTransactionList.value.length > 0);
const canTransfer = computed(() => apiWallet.value && !apiWallet.value.shared && apiWallet.value.balance > 0);

onMounted(() => {
  if (userAccount.value === null && useKeycloakStore().authenticated) {
    useAccountStore().loadAccount(profile.value.sub);
  }
  if (useKeycloakStore().authenticated) {
    useApimoneyStore().getApiWallet({
      walletId: f7route.params.wallet_id,
    });
  }
  if ((apiWallet.value !== "") & (apiWallet.value.groupId !== "")) {
  }
});

function uploadTransactions() {
  isLoading.value = true;
  useApimoneyStore().getApiWalletTransactions({
    walletId: f7route.params.wallet_id,
    start_date: null,
    end_date: null,
  });
  if (transactionList.value.length > 0) {
    isLoading.value = false;
  }
  console.log("transactionList", transactionList.value);
}
</script>
